/*eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import snackbar from '@/store/modules/snackbar';
import spinner from '@/store/modules/spinner';
import navigation from '@/store/modules/navigation';
import application from '@/store/modules/application';
import superadminapps from '@/store/modules/superadminApps';
import attachment from '@/plugins/attachment/modules/attachment';
import business from '@/store/modules/business';
import location from '@/store/modules/location';
import user from '@/store/modules/user';
import role from '@/store/modules/role';
import setting from '@/store/modules/setting';
import { isEmpty } from 'lodash'; 

const initialState = {
  navigation: navigation.state,
  application: application.state,
  superadminapps: superadminapps.state,
  attachment: attachment.state,
  business: business.state,
  location: location.state,
  user: user.state,
  role: role.state,
  setting: setting.state,
};

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    snackbar,
    spinner,
    navigation,
    application,
    superadminapps,
    attachment,
    business,
    location,
    user,
    role,
    setting,
  },
  plugins: [createPersistedState()],
  state: {
    loggedin: {
      token: '',
      step: '',
      userAccounts: [],
      access: {
        locations: false,
        users: false,
      },
      userSelectedAccount: {},
      userSelectedAccountBranding: {},
      user: {
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        id: '',
        status: '',
      },
    },
  },
  mutations: {
    USER_TOKEN(state, data) {
      state.loggedin.token = data;
    },
    USER_DETAILS(state, data) {
      state.loggedin.user = data;
    },
    USER_ACCOUNTS(state, data) {
      state.loggedin.userAccounts = data;
    },
    USER_SELECTED_ACCOUNT(state, data) {
      state.loggedin.userSelectedAccount = data;
    },
    USER_SELECTED_ACCOUNT_BRANDING(state, data) {
      state.loggedin.userSelectedAccountBranding = data;
    },
    USER_LOGIN_STEP(state, data) {
      state.loggedin.step = data;
    },

    CLEAR_USER_DATA(state) {
      /**
       * Clear all modules values while logout
       */
      Object.keys(state).forEach((key) => {
        Object.assign(state[key], initialState[key]);
      });

      state.loggedin = {
        token: '',
        step: '',
        userAccounts: [],
        userSelectedAccount: {},
        userSelectedAccountBranding: {},
        user: {
          first_name: '',
          last_name: '',
          phone: '',
          email: '',
          id: '',
          status: '',
        },
      };
    },

  },
  actions: {
    SET_USER_TOKEN({ commit }, data) {
      commit('USER_TOKEN', data);
    },
    SET_USER_DETAILS({ commit }, data) {
      commit('USER_DETAILS', data);
    },
    SET_USER_ACCOUNTS({ commit }, data) {
      commit('USER_ACCOUNTS', data);
    },
    SET_USER_SELECTED_ACCOUNT({ commit }, data) {
      commit('USER_SELECTED_ACCOUNT', data);
    },
    SET_USER_SELECTED_ACCOUNT_BRANDING({ commit }, data) {
      commit('USER_SELECTED_ACCOUNT_BRANDING', data);
    },
    SET_USER_LOGIN_STEP({ commit }, data) {
      commit('USER_LOGIN_STEP', data);
    },
    SET_USER_DATA_EMPTY({ commit }) {
      commit('CLEAR_USER_DATA');
    },
  },
  getters: {
    getLoggedInUserToken(state) {
      return state.loggedin.token;
    },
    getLoggedInUser(state) {
      return state.loggedin.user;
    },
    getLoggedInUserAccounts(state) {
      return state.loggedin.userAccounts;
    },
    getLoggedInUserSelectedAccount(state) {
      return state.loggedin.userSelectedAccount;
    },
    getLoggedInUserSelectedBusinessId(state) {
      return state.loggedin.userSelectedAccount.id;
    },
    getLoggedInUserSelectedBusinessBrandingLogo(state) {
      if(state.loggedin.userSelectedAccountBranding) {
        if (state.loggedin.userSelectedAccountBranding.logo) {
          return state.loggedin.userSelectedAccountBranding.logo;
        }
      }
      return '';
    },
    // Branding
    getLoggedInUserSelectedBusinessBrandingPrimary(state) {
      if(_.isEmpty(state.loggedin.userSelectedAccountBranding)) {
        return '#F03C0C';
      }
      if (!_.isEmpty(state.loggedin.userSelectedAccountBranding.brand_colors)) {
        if (state.loggedin.userSelectedAccountBranding.brand_colors.primary) {
          return state.loggedin.userSelectedAccountBranding.brand_colors.primary;
        }
      }
      return '#F03C0C';
    },

    getLoggedInUserSelectedBusinessBrandingSecondary(state) {
      if(_.isEmpty(state.loggedin.userSelectedAccountBranding)) {
        return '#333333';
      }
      if (!_.isEmpty(state.loggedin.userSelectedAccountBranding.brand_colors)) {
        if (state.loggedin.userSelectedAccountBranding.brand_colors.secondary) {
          return state.loggedin.userSelectedAccountBranding.brand_colors.secondary;
        }
      }
      return '#333333';
    },

    getLoggedInUserSelectedBusinessBrandingAccent(state) {
      if(_.isEmpty(state.loggedin.userSelectedAccountBranding)) {
        return '#ea9780';
      }
      if (!_.isEmpty(state.loggedin.userSelectedAccountBranding.brand_colors)) {
        if (state.loggedin.userSelectedAccountBranding.brand_colors.accent) {
          return state.loggedin.userSelectedAccountBranding.brand_colors.accent;
        }
      }
      return '#ea9780';
    },

    getLoggedInStep(state) {
      return state.loggedin.step;
    },

    is_admin(state) {
      if (state.loggedin.user.type === 'admin') {
        return true;
      }
      return false;
    },

    is_corporate(state) {
      if (state.loggedin.userSelectedAccount.corporate) {
        return true;
      }
      return false;
    },

    is_unoapp(state) {
      // If user is not usperadmin then try to check unoapp
      if (state.loggedin.user.type === 'unoapp') {
        return true;
      }
      return false;
    },

    is_superadmin(state) {
      if (state.loggedin.user.type === 'super') {
        return true;
      }
      return false;
    },

  },
});
